export default "__VITE_ASSET__e71e4651__"